exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#rightpanelcontainer{width:33%;overflow-x:visible}#rightestpanelcontainer{width:33%}#rightestpanel,#rightpanel{height:100%;width:100%;overflow-x:visible}#rightestpanel.expanded,#rightpanel.expanded{animation:fadeInRightCustom .7s ease-out}#paneloverlay{display:none}@keyframes fadeInRightCustom{0%{opacity:0;transform:translateX(100%)}to{opacity:1;transform:translateX(0)}}@media (max-width:768px){#rightestpanelcontainer,#rightpanelcontainer{width:100%}#rightestpanel,#rightpanel{width:100%!important;height:calc(100% - 30px)}#paneloverlay{position:fixed;display:block;width:100%;height:100%;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:2}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5305bb7c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/containers/panels.vue
// module id = 1509
// module chunks = 0